import React, { useEffect, useState } from 'react';
import { Grid, Typography } from '@mui/material';

import TableColumn from '../TableColumn';

import TabGridItem from './TabGridItem';

import { grayCellDay, grayCellDayMob, grayCellMonths } from '../cellStyles';

const MapMatrixGo = ({
  numCell,
  setDate,
  cheapestFlightPrice,
  handleNewSearch,
  isInUSD,
}) => {
  const [version, setVersion] = useState(0);
  const [prevResultsJson, setPrevResultsJson] = useState(
    JSON.stringify(window.vthws?.results)
  );

  // Fuerza re-render si cambia window.vthws.results
  useEffect(() => {
    const interval = setInterval(() => {
      const currentJson = JSON.stringify(window.vthws?.results);
      if (currentJson !== prevResultsJson && version > -1) {
        setPrevResultsJson(currentJson);
        setVersion(v => v + 1);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [prevResultsJson, version]);

  const tab = [];
  const isMobile = /*screenSizeWidth < 600*/ false;
  const minLength = isMobile ? numCell : 0;
  const flightMatrix = window.vthws?.results || [];
  const maxLength = isMobile ? 2 + minLength : flightMatrix?.length || 0;

  for (let index = minLength; index < maxLength; index++) {
    const goIndex = isMobile ? index - 1 : index;
    const arrayFlights = flightMatrix[goIndex] || [];
    const firstCell = arrayFlights[+goIndex];
    const dateSet = setDate(firstCell?.data?.[1]?.horaSalida + '');

    tab.push(
      <TabGridItem key={`date_go_${+goIndex}`}>
        {/* Día / Mes */}
        <Grid item>
          <Typography
            component="div"
            sx={index === maxLength - 1 ? grayCellDayMob : grayCellDay}
          >
            {dateSet?.day}
            <Typography component="span" sx={grayCellMonths}>
              {dateSet?.months}
            </Typography>
          </Typography>
        </Grid>

        {/* Columnas de vuelos */}
        {arrayFlights?.map((_, backIndex) => {
          const cell = flightMatrix?.[+backIndex]?.[+goIndex];
          return (
            <TableColumn
              key={`go_${+goIndex + backIndex}`}
              goIndex={goIndex}
              cell={cell}
              cheapestFlightPrice={cheapestFlightPrice}
              handleNewSearch={handleNewSearch}
              isInUSD={isInUSD}
            />
          );
        })}
      </TabGridItem>
    );
  }

  return <>{tab}</>;
};

export default MapMatrixGo;
